import {Component, OnInit, Output, EventEmitter, ViewContainerRef, ComponentFactoryResolver} from '@angular/core';
import { GlobalServices } from '../global.services';
import { baseUrls } from '../appConstant';

declare var $;

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  public globalurl = baseUrls['global'];

  constructor(private globalService: GlobalServices, public viewContainerRef: ViewContainerRef, public cfr: ComponentFactoryResolver) { }

  ngOnInit() {
    if(this.globalService.isBrowser){
      this.globalService?.hideHeader.next(false);
        this.globalService?.hideFooter.next(false);
    }
  }

  public SignupClick(): void  {
    // this.globalService.cameFrom = 'partner';
    this.globalService.viewcontainerhelper = this.viewContainerRef;
    this.globalService.triggerpartnersignup(this.viewContainerRef, this.cfr);
    // this.globalService.triggerSignUpForm();
  }

  public loginClick(): void  {
    // this.globalService.cameFrom = 'partner';
    this.globalService.viewcontainerhelper = this.viewContainerRef;
    this.globalService.triggerlogin(this.viewContainerRef, this.cfr);

    // this.globalService.triggerLoginForm();
  }

  ngAfterViewInit() {

    this.globalService.createTabs();
  }
}
